import { TextInput, TextInputProps } from '@mantine/core';
import { useApi } from 'api/api-context';
import panic from 'errors/panic';
import { nanoid } from 'nanoid';
import { useEffect, useMemo, useState } from 'react';

export interface PredefinedDataAutosuggestInputProps extends Omit<TextInputProps, 'list'> {
  predefinedDataTypeId?: number;
}

/**
 * Text input with autosuggest values loaded from predefined data.
 */
export default function PredefinedDataAutosuggestInputBase({
  predefinedDataTypeId,
  ...props
}: PredefinedDataAutosuggestInputProps) {
  const { getAction } = useApi();
  const [autosuggestValues, setAutosuggestValues] = useState<string[]>([]);
  const autosuggestListId = useMemo(nanoid, []);

  useEffect(() => {
    const getPredefinedData = getAction('PredefinedDataGetMixed');

    if (predefinedDataTypeId === undefined) {
      setAutosuggestValues([]);
      return;
    }

    getPredefinedData({ parameters: { predefinedDataTypeId: String(predefinedDataTypeId) } })
      .then((response) => setAutosuggestValues(response.map(({ key }) => key)))
      .catch(panic);
  }, [predefinedDataTypeId]);

  return (
    <>
      <datalist id={autosuggestListId}>
        {autosuggestValues.map((value) => (
          <option key={value} value={value} />
        ))}
      </datalist>
      <TextInput list={autosuggestListId} {...props} />
    </>
  );
}
